import GraphQLService from '../../service/GraphQLService';

const graphQLService = new GraphQLService();

// eslint-disable-next-line no-unused-vars
export default fetch => (event, eventsHistory) => {
  // console.info('event', event, eventsHistory);

  fetch(`/${event.siteId}/graphql`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `mutation { webeventMutation( data:
         ${graphQLService.escapeInputArg({
           page: window.location.href,
           referrer: window.document.referrer,
           timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
           event: event.type,
           data: JSON.stringify(event.data),
         })}  ) }`,
    }),
    credentials: 'include',
  })
    .then(response =>
      // console.info('response', response);
      // if (response.status !== 200) throw new Error(response.statusText);
      response.json(),
    )
    .then(json => json);
};



// WEBPACK FOOTER //
// ./src/tracking/listeners/index.js